const projects = [
  // ==========================================
  // FEATURED / CURRENT PROJECTS
  // ==========================================

  {
    id: 1,
    imgSrc: [
      { src: "/codeaegis/1.png" },
      { src: "/codeaegis/2.png" },
      { src: "/codeaegis/3.png" },
    ],
    heading: "CodeAegis",
    subHeading: "Building Digital Solutions That Drive Growth",
    paragraph:
      "CodeAegis is a technology company delivering modern digital solutions and services. I worked on the company website as a Senior Frontend Developer, building responsive and SEO-friendly interfaces using modern frontend technologies and implementing dynamic features through API integration.",
    webSrc: "https://codeaegis.com/",
    webLink: "Visit Website",
    featured: true,
  },

  {
    id: 2,
    imgSrc: [
      { src: "/smartcarrots/1.png" },
      { src: "/smartcarrots/2.png" },
      { src: "/smartcarrots/3.png" },
    ],
    heading: "SmartCarrots",
    subHeading: "Connecting Businesses Through Smart Referrals",
    paragraph:
      "SmartCarrots is a referral and lead management platform designed to connect businesses, partners, and connectors. I worked extensively on the frontend, including responsive UI development, dynamic API integration, authentication flows, lead management, payment journeys, notifications, wallet features, and real-time chat functionality.",
    webSrc: "https://dev.smartcarrots.com/",
    webLink: "Visit Website",
    featured: true,
  },

  {
    id: 3,
    imgSrc: [
      { src: "/lbw11/1.png" },
      { src: "/lbw11/2.png" },
      { src: "/lbw11/3.png" },
    ],
    heading: "LBW11",
    subHeading: "A Modern Digital Sports Experience",
    paragraph:
      "LBW11 is a modern digital sports platform focused on delivering an engaging and responsive user experience. My contribution focused on translating designs into responsive frontend interfaces and creating a smooth experience across desktop and mobile devices.",
    webSrc: "https://lbw11.com/",
    webLink: "Visit Website",
    featured: true,
  },

  {
    id: 4,
    imgSrc: [
      { src: "/bnea/1.png" },
      { src: "/bnea/2.png" },
      { src: "/bnea/3.png" },
    ],
    heading: "BNEA News App",
    subHeading: "A Modern Digital News Platform",
    paragraph:
      "The BNEA News App is a digital news platform project for the Bahamas National Exam Agency. The project focused on building a modern, structured, and responsive user experience by converting design concepts into production-ready frontend interfaces.",
    webSrc: "https://codeaegis.com/case-study/bnea-news-app",
    webLink: "View Case Study",
    featured: true,
  },

  // ==========================================
  // LIVE PROJECTS
  // ==========================================

  {
    id: 5,
    imgSrc: [
      { src: "/plushland/Screenshot1.png" },
      { src: "/plushland/Screenshot2.png" },
      { src: "/plushland/Screenshot3.png" },
    ],
    heading: "Plushland",
    subHeading: "Customized Stuffed Animals & Plush Products",
    paragraph:
      "Plushland creates high-quality customized stuffed animals and plush products. The project focused on delivering a visually engaging and responsive website experience.",
    webSrc: "",
    webLink: "Visit Website",
  },

  {
    id: 6,
    imgSrc: [
      { src: "/grocio.png" },
    ],
    heading: "Grocio",
    subHeading: "Online Grocery Shopping Experience",
    paragraph:
      "Grocio is an online grocery platform designed to provide users with a convenient and user-friendly digital shopping experience.",
    webSrc: "",
    webLink: "Visit Website",
  },

  {
    id: 7,
    imgSrc: [
      { src: "/vrcd/Screenshot1.png" },
      { src: "/vrcd/Screenshot2.png" },
      { src: "/vrcd/Screenshot3.png" },
    ],
    heading: "VR Club Direct",
    subHeading: "Business Development & Market Research",
    paragraph:
      "VR Club Direct is a professional platform focused on business development and market research, presented through a responsive and structured digital experience.",
    webSrc: "",
    webLink: "Visit Website",
  },

  {
    id: 8,
    imgSrc: [
      { src: "/mybagclub.png" },
      { src: "/mybagclub2.png" },
      { src: "/mybagclub3.png" },
    ],
    heading: "My Bag Club",
    subHeading: "A Digital Platform for Bag Enthusiasts",
    paragraph:
      "My Bag Club is an online platform focused on bags and related products, designed to create an accessible and engaging browsing experience.",
    webSrc: "",
    webLink: "Visit Website",
  },

  {
    id: 9,
    imgSrc: [
      { src: "/Waje Technologies/Screenshot1.png" },
      { src: "/Waje Technologies/Screenshot2.png" },
      { src: "/Waje Technologies/Screenshot3.png" },
    ],
    heading: "Waje Technologies",
    subHeading: "Broad-Spectrum Technology Solutions",
    paragraph:
      "Waje Technologies is a broad-spectrum technology solutions company focused on transforming businesses through advanced technology, managed support, consulting, and customized digital services.",
    webSrc: "https://wajetech.com/",
    webLink: "Visit Website",
  },

  {
    id: 10,
    imgSrc: [
      { src: "/Devine Attire/Screenshot1.png" },
      { src: "/Devine Attire/Screenshot2.png" },
      { src: "/Devine Attire/Screenshot3.png" },
    ],
    heading: "Devine Attire",
    subHeading: "Discover Elegance in Fashion",
    paragraph:
      "Devine Attire is a fashion-focused platform showcasing a diverse range of garments and accessories through a visually engaging and responsive digital experience.",
    webSrc: "https://www.devineattire.com/",
    webLink: "Visit Website",
  },

  {
    id: 11,
    imgSrc: [
      { src: "/JERAH BEAUTY/Screenshot1.png" },
      { src: "/JERAH BEAUTY/Screenshot2.png" },
      { src: "/JERAH BEAUTY/Screenshot3.png" },
    ],
    heading: "Jerah Beauty",
    subHeading: "A Modern Beauty Experience",
    paragraph:
      "Jerah Beauty is a beauty-focused digital platform designed to showcase services and create an engaging, modern online brand experience.",
    webSrc: "",
    webLink: "Visit Website",
  },

  {
    id: 12,
    imgSrc: [
      { src: "/Eterna Private Dept/Screenshot1.png" },
      { src: "/Eterna Private Dept/Screenshot2.png" },
      { src: "/Eterna Private Dept/Screenshot3.png" },
    ],
    heading: "Eterna Private Dept",
    subHeading: "Eterna | The Financial Group",
    paragraph:
      "Eterna Private Debt offers flexible and personalized interim financing solutions for real estate developers and promoters.",
    webSrc: "https://eternadetteprivee.ca/",
    webLink: "Visit Website",
  },

  {
    id: 13,
    imgSrc: [
      { src: "/Insignia Spaces/Screenshot1.png" },
      { src: "/Insignia Spaces/Screenshot2.png" },
      { src: "/Insignia Spaces/Screenshot3.png" },
    ],
    heading: "Insignia Spaces",
    subHeading: "Construction, Refurbishment & Fit-Out Solutions",
    paragraph:
      "Insignia Spaces provides construction, refurbishment, and fit-out solutions through a professional and visually structured digital presence.",
    webSrc: "",
    webLink: "Visit Website",
  },

  {
    id: 14,
    imgSrc: [
      { src: "/Hensen Window Systems/Screenshot1.png" },
      { src: "/Hensen Window Systems/Screenshot2.png" },
      { src: "/Hensen Window Systems/Screenshot3.png" },
    ],
    heading: "Hensen Window Systems",
    subHeading: "Professional Window System Solutions",
    paragraph:
      "Hensen Window Systems showcases specialized window products and solutions through a responsive and professional web experience.",
    webSrc: "",
    webLink: "Visit Website",
  },

  {
    id: 15,
    imgSrc: [
      { src: "/Send & Care/Screenshot1.png" },
      { src: "/Send & Care/Screenshot2.png" },
      { src: "/Send & Care/Screenshot3.png" },
    ],
    heading: "Send & Care",
    subHeading: "Secure Healthcare Support Platform",
    paragraph:
      "Send & Care is a healthcare-focused platform designed to help individuals support medical expenses through a digital ecosystem involving healthcare providers, pharmacies, and secure technology.",
    webSrc: "https://sendandcare.com/",
    webLink: "Visit Website",
  },

  {
    id: 16,
    imgSrc: [
      { src: "/Eterna/Screenshot1.png" },
      { src: "/Eterna/Screenshot2.png" },
      { src: "/Eterna/Screenshot3.png" },
    ],
    heading: "Eterna Groupe Financier",
    subHeading: "Pursuing Excellence for Four Generations",
    paragraph:
      "Eterna Financial Group provides financial products and services through its subsidiaries and shares market and economic insights through relevant content and expertise.",
    webSrc: "https://www.eterna.ca/fr/",
    webLink: "Visit Website",
  },

  {
    id: 17,
    imgSrc: [
      { src: "/LTY/Screenshot1.png" },
      { src: "/LTY/Screenshot2.png" },
      { src: "/LTY/Screenshot3.png" },
    ],
    heading: "LTY",
    subHeading: "The Digital Broker That Simplifies Insurance",
    paragraph:
      "LTY is a digital insurance intermediary focused on helping customers navigate insurance while maintaining an independent and customer-focused approach.",
    webSrc: "",
    webLink: "Visit Website",
  },

  {
    id: 18,
    imgSrc: [
      { src: "/Filli/Screenshot1.png" },
      { src: "/Filli/Screenshot2.png" },
      { src: "/Filli/Screenshot3.png" },
    ],
    heading: "Filli",
    subHeading: "The Golden-Spiced Tea",
    paragraph:
      "FiLLi is a globally recognized tea brand with partnerships across sports clubs and major events, creating a strong and engaging brand presence.",
    webSrc: "",
    webLink: "Visit Website",
  },

  {
    id: 19,
    imgSrc: [
      { src: "/idigitalweb/Screenshot1.png" },
      { src: "/idigitalweb/Screenshot2.png" },
      { src: "/idigitalweb/Screenshot3.png" },
    ],
    heading: "iDigital Web",
    subHeading: "Turning Digital Ideas into Reality",
    paragraph:
      "iDigital Web is a digital services company focused on web development and digital solutions. During my time there, I contributed to multiple client websites, admin panels, and frontend experiences.",
    webSrc: "",
    webLink: "Visit Website",
  },

  {
    id: 20,
    imgSrc: [
      { src: "/Swiftspend/Screenshot1.png" },
      { src: "/Swiftspend/Screenshot2.png" },
      { src: "/Swiftspend/Screenshot3.png" },
    ],
    heading: "Swiftspend",
    subHeading: "Fast and Simple Digital Money Transfers",
    paragraph:
      "Swiftspend is a digital financial platform designed to provide users with a simple and efficient money transfer experience.",
    webSrc: "",
    webLink: "Visit Website",
  },
];

export default projects;